"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _classnames = _interopRequireDefault(require("classnames")),
    _labelWrapper = require("../styles/labelWrapper");

function LabelWrapper(a) {
  var b = a.children,
      c = a.className,
      d = a.label,
      e = a.id,
      f = a.extraLabelContent;
  return d ? _react["default"].createElement("label", {
    className: (0, _classnames["default"])(_labelWrapper.LABEL_CONTAINER, c),
    htmlFor: e
  }, _react["default"].createElement("div", {
    className: _labelWrapper.LABEL_HEADER
  }, _react["default"].createElement("p", {
    className: _labelWrapper.LABEL
  }, d.toUpperCase()), f || null), b) : b;
}

var _default = (0, _react.memo)(LabelWrapper);

exports["default"] = _default;